// extracted by mini-css-extract-plugin
export default {"text":"FindingOpponent2_text__Ys+ot","text_vs":"FindingOpponent2_text_vs__jc+MA"};